export default __webpack_public_path__ + "static/backgroundPublisher-c59dc9c4248b1b119f6551f5bb1ed0bc.png";